import { render, staticRenderFns } from "./trendChart.vue?vue&type=template&id=47a4a4d8&scoped=true&"
import script from "./trendChart.vue?vue&type=script&lang=js&"
export * from "./trendChart.vue?vue&type=script&lang=js&"
import style0 from "./trendChart.vue?vue&type=style&index=0&id=47a4a4d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4a4d8",
  null
  
)

export default component.exports